module.exports = __webpack_public_path__ + "img/icon_master_perusahaan.ae2d115a.svg";